// Yup
import { number, string, object, array, boolean, mixed } from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { messagesTypesShape } from "./Shapes/MessagesTypesShape";

export const clinicValidationSchema = (selectedClient) =>
  object({
    name: string("Enter the clinic's name").required("Clinic name is required"),
    address: string("Enter the clinic's address").required(
      "Clinic address is required"
    ),
    city: string("Enter the clinic's city").required("Clinic city is required"),
    postalCode: string("Enter the clinic's postal code")
      .matches(
        /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/,
        "Postal code must be in the format A1A 1A1"
      )
      .required("Clinic postal code is required"),
    province: string().required("Clinic province is required"),
    phone: string()
      .test("is-valid-phone", "Invalid phone number", (value) => {
        if (!value) return false;
        const phoneNumber = parsePhoneNumberFromString(value, "CA");
        return phoneNumber ? phoneNumber.isValid() : false;
      })
      .required("Clinic phone number is required"),
    altPhone: string()
      .nullable()
      .test("is-valid-phone", "Invalid phone number", (value) => {
        if (!value) return true;
        const phoneNumber = parsePhoneNumberFromString(value, "CA");
        return phoneNumber ? phoneNumber.isValid() : false;
      }),
    french: object({
      name: string("Enter the clinic's name in French").required(
        "Clinic name in French is required"
      ),
      address: string("Enter the clinic's address in French").required(
        "Clinic address in French is required"
      ),
    }),
    appointmentSchedule: string().required(),
    appointmentSuggestions: array()
      .of(
        object().shape({
          suggestion: string().required("Suggestion is required"),
          type: array().when([], {
            is: () => selectedClient?.settings?.appointmentReasons,
            then: (schema) =>
              schema
                .min(1, "At least one type is required")
                .required("Types are required"),
            otherwise: (schema) => schema.optional(),
          }),
          length: number().required("Length is required"),
          isVisible: boolean(),
          overrideProviderIds: string().matches(
            /^(\d+\s*,\s*)*\d+$/,
            "Only numbers separated by commas are allowed"
          ),
        })
      )
      .test(
        "at-least-one-visible",
        "At least one suggestion must be visible",
        (value) => value?.some((suggestion) => suggestion.isVisible)
      )
      .required("Suggestions are required"),
    location: string()
      .nullable()
      .when("clientId", (clientId, schema) => {
        if (selectedClient?.settings?.appointmentLocations) {
          return schema.required(
            "Location is required for clients with appointment locations enabled"
          );
        }
        return schema;
      }),
    accuroClientId: string("Enter accuro client ID").required(
      "Accuro client ID is required"
    ),
    accuroClientSecret: string("Enter accuro client secret token").required(
      "Accuro client secret token is required"
    ),
    accuroSubscriptionKey: string("Enter accuro subscription key").required(
      "Accuro subscription key is required"
    ),
    accuroUUID: string("Enter accuro UUID").required("Accuro UUID is required"),
    accuroOfficeName: string("Enter accuro office name").required(
      "Accuro office name is required"
    ),
    clientId: string("Select a client").required("Client is required"),
    hoursOfOperationUrl: string()
      .nullable()
      .matches(/^https:\/\/.+/, "URL must start with https://"),
    customMessagesEnabled: boolean().required(
      "Custom messages enabled is required"
    ),
    customTextMessages: object()
      .shape(messagesTypesShape)
      .when("customMessagesEnabled", {
        is: true,
        then: (schema) => schema.required("Custom text messages are required"),
        otherwise: () => mixed().notRequired(),
      }),
  });
